import {
	AccelerationUnit,
	DataType,
	NoneType,
	OverpressureUnit,
	SoundUnit,
	VelocityUnit,
	VibrationSubType,
} from "@soft-db/data-formatter";
import { createPluginOptions } from "../create-plugin-options";

export const defaultEventListDataOptions = createPluginOptions()({
	type: "" as DataType,
	subType: "" as VibrationSubType | "",
	unit: "" as SoundUnit | AccelerationUnit | VelocityUnit | NoneType,
	oplUnit: "dB" as OverpressureUnit,
});

export type EventListDataOptions = typeof defaultEventListDataOptions;
